export const post = async (apiPath, model, reCaptchToken) => {
  try {
    // send API call
    const response = await fetch(
      `${process.env.GATSBY_API_ENDPOINT}${apiPath}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-api-key': process.env.GATSBY_X_API_KEY,
          'x-g-recaptcha': reCaptchToken,
        },
        body: JSON.stringify(model),
      },
    );
    if (!response.ok) {
      throw new Error('API call failed');
    }
    // API endpoint should return 2xx on success
    // no need to return any boolean
  } catch (err) {
    // API responds with error (4xx or 5xx)
    throw new Error('API call failed');
  }
};
